import { Attachment, Image, List, Mic, PinDrop, RadioButtonUnchecked, Reply } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React,{useEffect, useState} from 'react'
import { useChatInputProvider } from './chat-context/ChatInputContext';


const AutoLink = ({ text }) => {

	const delimiter = /((?:https?:\/\/)?(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;
  

	const boldDelimiter= /\*(.*?)\*/gi;

	return (
	  <>
		{text!== "" && text.split(delimiter).map(word => {
		  const match = word.match(delimiter);
		  if (match) {
			const url = match[0];
			return (
			  <a target='_blank' href={url.startsWith('http') ? url : `http://${url}`}>{url}</a>
			);
		  }
		  return <div dangerouslySetInnerHTML={{ __html: word.replace(boldDelimiter, "<b class='text-success' >$1</b>") }} />;
		})}
	  </>
)}

export const TextMessage = ({message}) =>{
  return (
	<>
		<div className='card'>
			<div className='card-body'>
				<span style={{whiteSpace: "pre-wrap"}} ><AutoLink text={message.messageBody} /></span>
			</div>
		</div>
	</>
  )
}


export const LocationRequest = ({message,callBack}) =>{
	const [dialogStatus, setDialogStatus] = useState(false);
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveList")
			setDialogStatus(false)
		} else{
			console.log("no callBack defined")
			setDialogStatus(false)
		}
	}
	const {locationInputDialogStatus,setLocationInputDialogStatus} = useChatInputProvider();
	return (
	  <>
		  <div className='card'>
			  <div className='card-body'>
				  {message.messageBody}
			  </div>
			  <div className='card-footer'>
			  	<button className='btn btn-outline-primary' onClick={()=>setLocationInputDialogStatus(true)} >Share Location</button>
			  </div>
			  {/*
			  <div className='card-footer'>
				Please click on <span className='btn btn-sm  mb-2 btn-primary'><Attachment/> </span> Attachment Button and Select <span className="btn btn-sm btn-outline-primary"><PinDrop/> Location </span> to share your current location
			  </div>
			  */}
		  </div>
	  </>
	)
  }
  
  export const LocationMessage = ({message,callBack}) =>{
	const [dialogStatus, setDialogStatus] = useState(false);
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveList")
			setDialogStatus(false)
		} else{
			console.log("no callBack defined")
			setDialogStatus(false)
		}
	}
	return (
	  <>
		  <div className='card'>
			  <div className='card-body'>
				<h5>{message.locationName},</h5>
				<p>{message.locationAddress}</p>
				<a target='_blank' href={"https://www.google.com/maps/dir//"+message.latitude+", "+message.longitude} >View On Map</a>
			  </div>
		  </div>
	  </>
	)
}


export const ImageRequest = ({message,callBack}) =>{
	const [dialogStatus, setDialogStatus] = useState(false);
	const {imageInputDialogStatus,setImageInputDialogStatus} = useChatInputProvider();
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveList")
			setDialogStatus(false)
		} else{
			console.log("no callBack defined")
			setDialogStatus(false)
		}
	}
	return (
	  <>
		  <div className='card'>
			  <div className='card-body'>
				  {message.messageBody}
			  </div>
			  <div className='card-footer'>
			  	<button className='btn btn-outline-primary' onClick={()=>setImageInputDialogStatus(true)} >Share Image</button>
			  </div>
			  {/*
			  <div className='card-footer'>
			  	Please click on <span className='btn btn-sm  mb-2 btn-primary'><Attachment/> </span> Attachment Button and Select <span className="btn btn-sm btn-outline-primary"><Image/>  Image </span> to share Image
			  </div>
			  */}
		  </div>
	  </>
	)
}

export const AudioRequest = ({message,callBack}) =>{
	const [dialogStatus, setDialogStatus] = useState(false);
	const {audioInputDialogStatus,setAudioInputDialogStatus} = useChatInputProvider();
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveList")
			setDialogStatus(false)
		} else{
			console.log("no callBack defined")
			setDialogStatus(false)
		}
	}
	return (
	  <>
		  <div className='card'>
			  <div className='card-body'>
				  {message.messageBody}
			  </div>
			  <div className='card-footer'>
			  	<button className='btn btn-outline-primary' onClick={()=>setAudioInputDialogStatus(true)} >Record Audio Message</button>
			  </div>
			  {/*
			  <div className='card-footer'>
				Please click on <button className='btn btn-sm btn-outline-success'><Mic/></button> Mic Button to record your message
			  </div>
			  */}
		  </div>
	  </>
	)
}
  



export const InteractiveReply = ({message,callBack}) =>{
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveReply")
		} else{
			console.log("no callBack defined")
		}
	}
	return (
		<div className='card'>
			<div className='card-body'>
				<h5>{message.headerText}</h5>
				<h6>{message.bodyText}</h6>
				<h6 className='text-muted'>{message.footerText}</h6>
				{message.optionList && message.optionList.map((option,i)=>
					<button key={i} className='btn btn-dark bg-white text-dark m-2'  onClick={()=>handleClick(option)}>{option.optionTitle}</button>
				)}
			</div>
		</div>
	)
}


export const InteractiveList = ({message,callBack}) =>{
	const [dialogStatus, setDialogStatus] = useState(false);
	const handleClick = (option) =>{
		if(callBack!==undefined){
			callBack(option,"interactiveList")
			setDialogStatus(false)
		} else{
			console.log("no callBack defined")
			setDialogStatus(false)
		}
	}
	return (
		<div className='card'>
			<div className='card-body'>
				<h5>{message.headerText}</h5>
				<h6>{message.bodyText}</h6>
				<h6 className='text-muted'>{message.footerText}</h6>
			</div>  
			<div className='card-footer text-center'>
				<button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)} ><List/> {message.menuButtonTitle}</button>		
			</div>
			<Dialog
				open={dialogStatus}
				keepMounted
				onClose={()=>setDialogStatus(false)}
				maxWidth="sm"
				fullWidth={true}
			>
				<DialogTitle>{message.optionListTitle}</DialogTitle>
				<DialogContent>
					<ul className="list-group">
					{message.optionList && message.optionList.map(option=>
					<li className="list-group-item d-flex justify-content-between align-items-center" key={option.id} onClick={()=>handleClick(option)} >
						<span>
						<div className='fs-5'>{option.optionTitle} </div>
						{option.optionDescription !== "" && <div>{option.optionDescription}</div> }
						</span>
						<span><RadioButtonUnchecked /></span>
						</li>
					)}
					</ul>
				</DialogContent>
			</Dialog>
		</div>
	)
}


export const MessageTemplate = ({message,messageType, callBack}) =>{
	return (
		<>
			{messageType === "text" && <TextMessage message={message} />}
            {messageType === "interactiveReply" && <InteractiveReply message={message} callBack={callBack} /> }
            {messageType === "interactiveList" && <InteractiveList message={message} callBack={callBack} /> }
			{messageType === "locationRequest" && <LocationRequest message={message} callBack={callBack} />}
			{messageType === "imageRequest" && <ImageRequest message={message} callBack={callBack} />}
			{messageType === "audioRequest" && <AudioRequest message={message} callBack={callBack} />}
			{messageType === "locationMessage" && <LocationMessage message={message} callBack={callBack} />}
		</>
	)
}





